import React, { useState } from "react";

function LanguageSearch({ onSearch, onCreate }) {
    const [name, setName] = useState('');

    const handleSubmit = e => {
        e.preventDefault();
        onSearch(name);
    };

    return (
        <div className="search-container">
            <form onSubmit={handleSubmit}>
                <label>
                    Name {' '}
                    <input type="text" value={name} onChange={e => setName(e.target.value)} />
                </label>
                {' '}
                <button type="submit">Search</button>
                {' '}
                <button type="button" onClick={onCreate}>Create</button>
            </form>
        </div>
    );
}

export default LanguageSearch;
